/**
 * Status dropdown trigger (pill) — design: colored badge + chevron
 */
export const STATUS_TRIGGER: Record<string, { bg: string; color: string }> = {
  working: { bg: 'var(--green-200)', color: 'var(--green-700)' },
  day_off: { bg: 'var(--red-50-soft)', color: 'var(--red-700)' },
  holiday: { bg: 'var(--red-50-soft)', color: 'var(--red-700)' },
  training: { bg: 'var(--gray-100)', color: 'var(--gray-600)' },
  left: { bg: 'var(--gray-100)', color: 'var(--gray-600)' },
  other: { bg: 'var(--gray-100)', color: 'var(--gray-600)' }
};

export const DEFAULT_STATUS_TRIGGER = { bg: '#E5E7EB', color: '#374151' };

export const STATUS_OPTION_LIST = [
  { value: 'working', label: 'Working' },
  { value: 'day_off', label: 'Day off' },
  { value: 'holiday', label: 'Holiday' },
  { value: 'training', label: 'Training' },
  { value: 'left', label: 'Left' },
  { value: 'other', label: 'Other' }
] as const;

export const SHIFT_OPTION_LIST = [
  { value: 'morning', label: 'Morning' },
  { value: 'evening', label: 'Evening' }
] as const;

export const DELTA_PILL = {
  positive: { text: '#DC2626', bg: 'transparent' },
  negative: { text: '#DC2626', bg: 'transparent' },
  /** Zero: small green “Match” pill in delta column (design) */
  zero: { text: '#166534', bg: '#DCFCE7' }
} as const;

export const STATUS_KEYS = {
  PENDING: 'pending',
  MATCHED: 'matched',
  UNMATCHED: 'unmatched',
  ENTRY_NOT_DONE: 'entry_not_done'
} as const;

export const MATCH_STATUS: Record<
  StatusKey,
  { bg: string; text: string; label: string }
> = {
  [STATUS_KEYS.PENDING]: {
    bg: '',
    text: '',
    label: '--'
  },
  
  [STATUS_KEYS.MATCHED]: {
    bg: 'var(--green-200)',
    text: 'var(--green-500)',
    label: 'Match'
  },
  
  [STATUS_KEYS.UNMATCHED]: {
    bg: 'var(--red-100)',
    text: 'var(--red-800)',
    label: 'Unmatched'
  },
  
  [STATUS_KEYS.ENTRY_NOT_DONE]: {
    bg: 'var(--gray-200)',
    text: 'var(--gray-700)',
    label: 'Entry not done'
  }
};

export type StatusKey =
  typeof STATUS_KEYS[keyof typeof STATUS_KEYS];

export const DROPDOWN_PLAIN = {
  bg: 'var(--white)',
  color: 'var(--gray-900)',
  border: '1px solid var(--gray-300)'
};

export type ShiftOption = 'Morning' | 'Evening';
export type OpeningStatus = 'send' | 'sent';
export type MatchStatus = 'pending' | 'matched' | 'unmatched' | 'entry_not_done' | '--';
export type CashReconciliationReportRowStatus = 'active' | 'on_leave';